import React, { useEffect, useState } from "react";
import { Modal, Segment } from "semantic-ui-react";
// UI
import CardConsultCancelDetailUX from "./CardConsultCancelDetailUX";
import { useIntl } from "react-intl";

type CardConsultCancelDetailProps = {
  onCloseMod?: any;
  isOpen?: boolean;
  cancel_note?: string;
  cancel_user?: string;
  languageUX?: string;
};

const CardConsultCancelDetail = (props: CardConsultCancelDetailProps) => {
  const intl = useIntl();
  const [cancelNote, setCancelNote] = useState<string>("");
  const [cancelReason, setCancelReason] = useState<string>("");

  useEffect(() => {
    if (props.cancel_note) {
      const [note, reason] = props.cancel_note.split(":", 2).map(str => str.trim());
      setCancelNote(note);
      setCancelReason(reason || "");
    }
  }, [props.cancel_note]);
  
  return (
    <Modal closeIcon size="tiny" open={props.isOpen} onClose={props.onCloseMod}>
      <Segment inverted className="red" style={{ margin: "0px" }}>{intl.formatMessage({ id: "นัดหมายถูกยกเลิก" })}</Segment>
      <Modal.Content>
        <CardConsultCancelDetailUX
          cancel_note={cancelNote}
          cancel_reason={cancelReason}
          cancel_user={props.cancel_user}
          languageUX={props.languageUX}
        />
      </Modal.Content>
    </Modal>
  );
};

export default React.memo(CardConsultCancelDetail);
